var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7794_56291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66624 16.3491L4.58984 16.4255L4.88452 20.4855H19.7822L20.0878 16.3491H4.66624Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0769 7.57419L19.7822 3.51416H4.88452L4.58984 7.65059H20.0114L20.0769 7.57419Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 23.5632C11.4355 20.7958 10.0735 18.2541 8.08238 16.2508C6.08057 14.2636 3.5435 12.9021 0.780884 12.3327V11.6669C3.54503 11.1017 6.08324 9.7396 8.08238 7.74876C10.0732 5.74962 11.4353 3.21141 12.0005 0.447266H12.6663C13.2357 3.20988 14.5972 5.74695 16.5844 7.74876C18.5877 9.73991 21.1294 11.1018 23.8968 11.6669V12.3327C21.1267 12.89 18.583 14.2533 16.5849 16.2513C14.5869 18.2493 13.2236 20.7931 12.6663 23.5632H12.0005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61169 16.4149L17.0537 3.97286L19.0619 3.9292L20.066 7.59632L7.80951 19.8528L5.68127 20.1366L4.61169 16.4149Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3443 11.307C21.5305 10.8013 18.9377 9.44971 16.9118 7.43247C14.8877 5.41164 13.5349 2.81658 13.0373 0L11.6403 0C11.1373 2.81475 9.78536 5.40827 7.76584 7.43247C5.74165 9.45198 3.14812 10.804 0.333374 11.307L0.333374 12.704C3.14866 13.1985 5.74357 14.5474 7.76584 16.5675C9.78504 18.5963 11.1368 21.1932 11.6403 24.0109H13.0373C13.5293 21.1917 14.8792 18.593 16.9028 16.5695C18.9264 14.5459 21.5251 13.196 24.3443 12.704V11.307ZM16.2897 15.9454C14.3363 17.8819 12.9671 20.3289 12.3388 23.0068C11.7087 20.3321 10.3441 17.8864 8.39886 15.9454C6.4552 13.998 4.00542 12.6332 1.32655 12.0055C4.00373 11.3734 6.45239 10.0092 8.39886 8.06549C10.3426 6.11902 11.7067 3.67036 12.3388 0.993179C12.9666 3.67205 14.3314 6.12183 16.2788 8.06549C18.2198 10.0107 20.6654 11.3753 23.3402 12.0055C20.6635 12.6307 18.2166 13.996 16.2788 15.9454H16.2897Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7794_56291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.0cf875cdc07d7ecb44af539cf75863e3.svg";
export { ForwardRef as ReactComponent };